import React from 'react';
import Button from '@atlaskit/button';
import EditorAddIcon from '@atlaskit/icon/glyph/editor/add';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

type EditorCellViewProps = {
	isDisabled: boolean;
} & Intl & {
		onAdd: () => void;
		day: string;
	};

const AddView = ({ intl: { formatMessage }, onAdd, isDisabled, day = '' }: EditorCellViewProps) => (
	<Button
		testId="servicedesk-sla-settings.ui.calendars.editable.fields.work-week.day-with-working-times.add.button"
		appearance="subtle"
		isDisabled={isDisabled}
		iconAfter={<EditorAddIcon label="" />}
		onClick={onAdd}
		aria-label={formatMessage(messages.add, { day })}
	/>
);

export const Add = injectIntl(AddView);
